import { render, staticRenderFns } from "./AccidentIntakeConfirmSubmitForm.vue?vue&type=template&id=6ae2c2d5&scoped=true"
import script from "./AccidentIntakeConfirmSubmitForm.vue?vue&type=script&lang=js"
export * from "./AccidentIntakeConfirmSubmitForm.vue?vue&type=script&lang=js"
import style0 from "./AccidentIntakeConfirmSubmitForm.vue?vue&type=style&index=0&id=6ae2c2d5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae2c2d5",
  null
  
)

export default component.exports